import { ObjectRepository } from '@framework/repository';
import { RTDBPath } from 'balus-common';
import { UserPublicProfile } from './UserPublicProfile';
import type { UserId, UserPublicProfileJSON } from 'balus-common';

type UserPublicProfileRepository = ObjectRepository<UserPublicProfileJSON, UserPublicProfile>;
export const createUserPublicProfileRepository = (userId: UserId): UserPublicProfileRepository => {
  return new ObjectRepository(UserPublicProfile, RTDBPath.User.publicProfilePath(userId));
};
